import React from 'react';
import { Box, TextField, Typography } from '@mui/material';

interface Props {
  label: string;
  description?: string;
  value: number | null;
  onChange: (v: number | null) => void;
  placeholder?: string;
}

const NumberField: React.FC<Props> = ({ label, description, value, onChange, placeholder }) => (
  <Box>
    <Typography sx={{ fontSize: 13, fontWeight: 600, color: '#141417', mb: 0.5, fontFamily: 'Manrope, sans-serif' }}>{label}</Typography>
    {description && <Typography sx={{ fontSize: 11, color: '#6F6F6F', mb: 0.5 }}>{description}</Typography>}
    <TextField
      fullWidth
      size="small"
      type="number"
      value={value ?? ''}
      onChange={(e) => onChange(e.target.value === '' ? null : Number(e.target.value))}
      placeholder={placeholder}
      InputProps={{ sx: { fontSize: 13, borderRadius: '6px', width: 180 } }}
    />
  </Box>
);

export default NumberField;
